import { render, staticRenderFns } from "./ListActive.vue?vue&type=template&id=a16c9514&scoped=true"
import script from "./ListActive.vue?vue&type=script&lang=js"
export * from "./ListActive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16c9514",
  null
  
)

export default component.exports